
import { createClient } from '@supabase/supabase-js';

const config = (window as any).__APP_CONFIG__;

const DEFAULT_URL = 'https://api.db.hfli.org';
const DEFAULT_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpYXQiOjE3NjcwNjExMDgsImV4cCI6MTg5MzQ1NjAwMCwicm9sZSI6ImFub24iLCJpc3MiOiJzdXBhYmFzZSJ9.wFjmXxrJH0aCraTSK0L6A8HNXXwzvYUH2IJECwIC3C0';

const supabaseUrl = config?.SUPABASE_URL || DEFAULT_URL;
const supabaseAnonKey = config?.SUPABASE_ANON_KEY || DEFAULT_KEY;

// Using BrowserRouter allows us to rely on the SDK's native session detection.
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true // The SDK now natively scans the standard URL query string for ?code=
  }
});
